import handleError from '../errors';
import api from './instance';

export default async function PerformRequest(url, method, body, params) {
  try {
    const response = await api.request({
      method: method,
      url: url,
      data: body,
      params: params,
    });

    return response?.data;
  } catch (error) {
    handleError(error);
    throw error;
  }
}
